import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { templateKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useTemplate = (target, enabled = true) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: templateKeys.doc(target),
        queryFn: () => axios.get(markUrl('templates/get/'), {
            ...additional,
            params: target
        }),
        enabled,
        staleTime: 15_000
    });
};
export default useTemplate;
